import type { MoneyProps } from '@platform-ui/money';
import Money from '@platform-ui/money';

export const MoneyPh = (moneyProps: MoneyProps) => (
  <Money
    currency="PHP"
    symbolPosition="prefix"
    digitGroupingSeparator=","
    decimalSeparator="."
    precision={2}
    showSmalls
    styledSmalls={false}
    {...moneyProps}
  />
);
